import type { LocalPersistContext } from '../domain/LocalPersistContext.ts';
import {
  shouldBlockStorageQuota,
  STORAGE_QUOTA_BLOCK_MESSAGE_ES,
} from '@src/modules/sync/domain/storageQuotaWarning.ts';
import { sumDataUrlBytes } from '@src/modules/sync/domain/estimateMediaPayloadBytes.ts';

/** Flushes IndexedDB export after a SQLite mutation when hooks are wired. */
export async function flushLocalPersistAfterMutation(ctx: LocalPersistContext | undefined): Promise<void> {
  if (!ctx?.flushAfterMutation) return;
  await ctx.flushAfterMutation();
}

/** Rejects save when origin quota would be exceeded by new embedded media. */
export async function rejectIfStorageQuotaBlocksSave(
  ctx: LocalPersistContext | undefined,
  mediaDataUrls: readonly string[],
): Promise<string | null> {
  if (!ctx?.readStorageEstimate) return null;
  const est = await ctx.readStorageEstimate();
  if (!est) return null;
  const projected = est.usageBytes + sumDataUrlBytes(mediaDataUrls);
  if (!shouldBlockStorageQuota(projected, est.quotaBytes)) return null;
  return STORAGE_QUOTA_BLOCK_MESSAGE_ES;
}
